import React from "react";
import styled from "styled-components";

const Img = styled.div`
  height: 45px;
  width: 45px;
  background-size: cover;
  background-image: url(${({ src }) => src});
`;

export default ({ title, avatar }) => (
  <div className="bg-white white pv3 h2 ph2 mr3 flex flex-column fr min-w-10">
    <div className="flex flex-row items-center">
      <div className="black center ph3 ">{title}</div>
      <div className="ml-auto flex items-center">
        <Img src={avatar} className="br-100 ba  b--blue dib-ns cover bw1 dn " />
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/generic/kit/Avatar/index.js